import { Link, useParams } from "react-router-dom";
import { CustomComponentProps } from "utils/types/generalTypes";
import SVG from "../core/SVG";
import IconInput from "../inputs/IconInput";
import { useSelector } from "react-redux";
import { RootState } from "services/redux/store";
import ToolTipV2 from "../core/ToolTipV2";
import useWindowSize from "utils/hooks/useWindowSize";

export type UsersPagesHeaderProps = CustomComponentProps & {
    active?: "Followers" | "Indirect Followers" | "Following" | "";
    children: React.ReactNode;
    filterValue: string;
    setFilterValue: React.Dispatch<React.SetStateAction<string>>;
};

const UsersPagesHeader = ({
    active = "",
    children,
    filterValue,
    setFilterValue,
    className,
    style
}: UsersPagesHeaderProps) => {
    const { name, userName } = useSelector((state: RootState) => state.account);
    const [windowWidth] = useWindowSize();

    const params = useParams();
    console.log(params);

    return (
        <div className={`profile-followers-div ${className}`} style={style}>
            <div
                className={`profile-name-container d-flex${windowWidth < 567 ? " flex-col flex-a-start" : " flex-j-between flex-a-center"} gap-10`}
            >
                <div className="d-flex flex-j-start flex-a-center gap-10">
                    <Link
                        // to={"/"}
                        to={
                            params.backto && params.backto == "1"
                                ? `/`
                                : params.backto && params.backto == "2"
                                  ? `/profile/${userName}`
                                  : "/"
                        }
                    >
                        <SVG svg="arrow-left" size={24} />
                    </Link>
                    <div className="subheader-middle">
                        <h2 className="white-text">{name}</h2>
                        <span>@{userName}</span>
                    </div>
                </div>
                <div
                    className={`d-flex flex-j-between flex-a-center gap-10${windowWidth < 567 ? " w-full" : ""}`}
                >
                    <IconInput
                        value={filterValue}
                        handleChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                        ) => setFilterValue(e.target.value)}
                        rounded
                        style={{ marginBottom: 0 }}
                    />
                    <ToolTipV2 className="text-center" text="Add User">
                        <Link to="/add-user">
                            <SVG svg="add-user" size={26} className=" mr-15" />
                        </Link>
                    </ToolTipV2>
                </div>
            </div>
            <div className="profile-followers-card card mt-20">
                <ul className="profile-followers-tabs-ul w-full d-flex flex-j-between flex-a-center">
                    <li
                        className={`${active == "Followers" ? "is-active" : ""}  profile-followers-tabs-li`}
                    >
                        <Link
                            to={`/profile/${userName}/followers/${params.backto}`}
                            className="grey-text d-flex flex-j-center flex-a-center gap-5"
                        >
                            <SVG
                                svg="user-double-check"
                                size={16}
                                className="blue-white-svg"
                            />
                            <span className="white-text">Followers</span>
                        </Link>
                    </li>
                    {/* <li
                        id="incident-tab-li"
                        className={`${active == "Indirect Followers" ? "is-active" : ""}  profile-followers-tabs-li`}
                    >
                        <Link
                            to={`/profile/${userName}/indirect-followers`}
                            className="grey-text d-flex flex-j-center flex-a-center gap-5"
                        >
                            <SVG
                                svg="curved-arrow"
                                size={16}
                                className="blue-white-svg"
                            />
                            <span className="white-text">
                                Indirect Followers
                            </span>
                        </Link>
                    </li> */}
                    <li
                        id="incident-tab-li"
                        className={`${active == "Following" ? "is-active" : ""}  profile-followers-tabs-li`}
                    >
                        <Link
                            to={`/profile/${userName}/following/${params.backto}`}
                            className="grey-text d-flex flex-j-center flex-a-center gap-5"
                        >
                            <SVG
                                svg="followed"
                                size={16}
                                className="blue-white-svg"
                            />
                            <span className="white-text">Following</span>
                        </Link>
                    </li>
                </ul>
                <div
                    className={` profile-followers-container pt-20 pl-20 pr-20 pb-20 d-flex flex-col flex-j-between`}
                >
                    {children}
                </div>
            </div>
        </div>
    );
};

export default UsersPagesHeader;
